import {RecordForm} from '../forms/RecordForm';


import {useApplicationProduct} from '../hooks/useApplicationProduct.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate, useParams} from "react-router-dom";
import {moduleConfig} from "../config";
import {ApplicationProduct} from "../types.ts";


export const AddPage = () => {

    const navigate = useNavigate();
    const {id: applicationId} = useParams()

    if (!applicationId) {
        throw new Error('applicationId is required');
    }

    const {
        record,
        createRecord,
    } = useApplicationProduct(applicationId);

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as ApplicationProduct} handleSubmit={createRecord} handleCancel={() => navigate(`/applications/${applicationId}`)}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
